<template lang="pug" >
div
  v-dialog(v-model='dialogComputed' max-width='850px' @click:outside="closeDialog()")
    v-card(style='max-width: 100%;')
      v-toolbar.toolbar-settings.text-settings(style='z-index: 99999; position: sticky; top: 0;')
        span(style='font-size: 1.125rem;shaped line-height: 1.4em; font-weight: 300; font-size: 18px;')
          | {{campaignId ? 'ID: ' + campaignId : $t('campaign.createCampaign')}}
        v-spacer
        v-btn#closeIcon(icon color='white' @click='closeDialog()')
          md-icon close
      v-form.pa-0(ref="registerCampaign")
        v-skeleton-loader(
          v-if="loadingItem"
          type="list-item-avatar-two-line, list-item-avatar-two-line,list-item-avatar-three-line, list-item-avatar-two-line, list-item-avatar-three-line"
          max-width="300"
          heigth="auto"
        )
        v-stepper.stepper(v-else v-model="step" vertical rounded)
          v-stepper-step(:complete="isStepCompleted(1)" :step="1"
            :color='method === "view" ? "#9E9E9E" : "#43a047"'
            edit-icon="$complete"
            :editable="isStepCompleted(1) && !methodIsView"
          ) {{ $t('campaign.campaignStatus')}}
            small.stepper-small-description(v-if="isStepCompleted(1) && step !== 1") {{campaign.active ?$t('commonWords.enabled') : $t('commonWords.disabled')}}
          v-stepper-content(:step="1")
            v-card-text.d-flex.flex-column.sectionGapPadding
              .d-flex.justify-space-between.align-center
                .d-flex.align-center
                  md-switch(v-model='campaign.active' :disabled='editDisabled')
                  span {{$t('campaign.enableCampaign')}}
                span {{campaign.active ? $t('commonWords.enabled') : $t('commonWords.disabled')}}
              .d-flex(style='gap: 1rem;')
                v-btn(color='#43a047' style='color: white;' @click='nextStep()' :disabled='methodIsView') {{$t('commonWords.continue')}}
          v-stepper-step(
            :complete="isStepCompleted(2)"
            :step="2"
            :color='method === "view" ? "#9E9E9E" : "#43a047"'
            :rules="[() => step < 3 || !!campaign.name, () => step < 3 || !showNameError ]"
            :editable="isStepCompleted(2) && !methodIsView"
            edit-icon="$complete"
          ) {{$t('commonWords.name')}}
            small.stepper-small-description(v-if="isStepCompleted(2) && step !== 2") {{ campaign.name }}
          v-stepper-content(:step="2")
            .d-flex.flex-column.sectionGapPadding
              div
                v-text-field.shaped(
                  v-model='campaign.name'
                  :disabled='editDisabled'
                  filled
                  dense
                  :rules="[() => !!campaign.name || $t('commonPhrases.requiredField')]"
                  :placeholder="$t('campaign.campaignName')"
                  @input="debouncedNameValidation($event)"
                  :error="showNameError"
                  :error-messages="showNameError ? $t('campaign.duplicatedName') : ''"
                )
                v-text-field.shaped(
                  v-model='campaign.description'
                  :disabled='editDisabled'
                  filled
                  dense
                  :placeholder="$t('campaign.campaignDescription')"
                )
              .d-flex(style='gap: 1rem;')
                v-btn(
                color='#43a047'
                style='color: white;'
                @click='nextStep()'
                :disabled="!campaign.name || showNameError || methodIsView"
                )
                  | {{$t('commonWords.continue')}}
                v-btn(text @click='prevStep()' :disabled='methodIsView') {{$t('commonWords.cancel')}}
          v-stepper-step(
            :complete="isStepCompleted(3)" :step="3"
            :color='method === "view" ? "#9E9E9E" : "#43a047"'
            :rules="[() => step < 4 || !!selectedTemplate._id]"
            :editable="isStepCompleted(3) && !methodIsView"
            edit-icon="$complete"
          ) {{$t('campaign.template')}}
            small.stepper-small-description(v-if="isStepCompleted(3) && step !== 3 && !methodIsView")
              | {{ selectedTemplate.name }}
            .template-preview(v-if="methodIsView" style="color: #ABB7C2; font-size: 14px !important; font-weight: 400 !important; margin-top: 5px;")
              p {{ selectedTemplate.name }}
              div {{$t('campaign.templateBodyMessageLabel')}}
                TextEditor.text-editor(ref="texEditor" :value="textMessage" disabled theme="bubble")
                .d-flex.flex-wrap(v-if="hasQuickReplies" style="gap: 1rem;")
                  v-btn(
                    v-for="quickReply in selectedTemplate.messageOptions.options.quick_replies"
                    :key="quickReply.content"
                    disabled
                  ) {{quickReply.title}}
          v-stepper-content(:step="3")
            .d-flex.flex-column.sectionGapPadding
              div
                v-autocomplete(
                  v-model="selectedTemplate"
                  :label="$t('campaign.selectTemplate')"
                  :items="templateOptions"
                  return-object
                  autocomplete="off"
                  item-text="name"
                  :disabled='editDisabled'
                  :rules="[() => !!selectedTemplate._id || $t('commonPhrases.requiredField')]"
                  filled
                  shaped
                  )
                  template(v-slot:append-item)
                    div(v-intersect="onIntersect")
                .template-preview(v-if="selectedTemplate._id")
                  div {{$t('commonWords.channel')}}:
                    span(v-for="(channel, index) in activeChannels" :key="channel.name") {{channel.name}}
                      span(v-if="index < activeChannels.length - 1")
                        | ,
                  div {{$t('campaign.templateText')}}:
                    TextEditor.text-editor(ref="texEditor" :value="textMessage" disabled theme="bubble")
                  .quick-replies-buttons
                    .d-flex.flex-wrap(v-if="hasQuickReplies" style="gap: 1rem;")
                      v-btn(
                        v-for="quickReply in selectedTemplate.messageOptions.options.quick_replies"
                        :key="quickReply.content"
                        disabled
                      ) {{quickReply.title}}
              .d-flex(style='gap: 1rem;')
                v-btn(color='#43a047' style='color: white;' @click='nextStep()'
                :disabled="!selectedTemplate._id || methodIsView")
                  | {{$t('commonWords.continue')}}
                v-btn(text @click='prevStep()' :disabled='methodIsView') {{$t('commonWords.cancel')}}
          v-stepper-step(
            :complete="isStepCompleted(4)"
            :step="4"
            :color='method === "view" ? "#9E9E9E" : "#43a047"'
            :editable="isStepCompleted(4) && !methodIsView"
            edit-icon="$complete"
          ) Mailing
            div(v-if="methodIsView" style='padding-top: 10px; color: #ABB7C2; font-size: 14px !important; font-weight: 400 !important;')
              MailingRecipientsListPreview(:recipients='recipients')
              span(v-if="recipients.length === 0") {{ $t('campaign.noRecipients') }}
          v-stepper-content(:step="4")
            MailingRecipientsListPreview(:recipients='recipients')
            MailingRecipientsListPreview(:recipients='newRecipients')
            div.d-flex.flex-column(style='max-width: 50%;')
              v-btn(
                color="#F19D38"
                :disabled="editDisabled"
                @click.stop='addRecipientsManually()')
                v-icon(style='padding-right: 4px;') mdi-plus
                span(style='text-transform: uppercase') {{$t('campaign.insertRecipient')}}
              .d-flex
                .d-flex.flex-column.align-end
                  v-btn.mt-4.mr-2(
                    color="#F19D38"
                    :disabled="editDisabled"
                    @click='importFile()')
                    v-icon(style='padding-right: 4px;') mdi-upload
                    span {{$t('campaign.importFile')}}
                  span(:style="{paddingRight: '10px'}") Formato .csv ou .xlsx
                v-btn.mt-4(
                  color="#26C6DA"
                  :disabled="editDisabled"
                  @click='downloadTemplateFile()')
                  v-icon(style='padding-right: 4px;') mdi-download
                  span {{$t('campaign.fileTemplate')}}
            v-card-text.d-flex.flex-column.sectionGapPadding
              .d-flex.justify-space-between.align-center
                .d-flex.align-center
                  md-switch(v-model='campaign.hideSensitiveContent' :disabled='editDisabled')
                  span {{$t('campaign.hideSensitiveContent')}}
                span {{campaign.hideSensitiveContent ? $t('commonWords.enabled') : $t('commonWords.disabled')}}
            v-file-input(
              v-show="file"
              id="uploader"
              truncate-length="25"
              @change="onFileChanged"
              @click="clearFile"
            ).pr-n2
            .d-flex(style='gap: 1rem; margin-top: 10px; margin-bottom: 10px;')
              v-btn(color='#43a047' style='color: white;' @click='nextStep()' :disabled='methodIsView') {{$t('commonWords.continue')}}
              v-btn(text @click='prevStep()' :disabled='methodIsView') {{$t('commonWords.cancel')}}
          v-stepper-step(
            :complete="isStepCompleted(5)"
            :step="5"
            :color='method === "view" ? "#9E9E9E" : "#43a047"'
            :editable="isStepCompleted(5) && !methodIsView"
            edit-icon="$complete"
          ) {{$t('campaign.trigger')}}
            small.stepper-small-description(v-if="isStepCompleted(5) && step !== 5 && !methodIsView") {{ selectedTriggerTypeName }}
            div(v-if='methodIsView' style='padding-top: 10px; color: #ABB7C2; font-size: 14px !important; font-weight: 400;')
              TriggerTypePreview(
                :schedule='{...interval, startDate, endDate}'
                :triggerTypeArray='triggerType'
                :weekdaysArray='weekdays'
              )
          v-stepper-content(:step="5")
            .d-flex
              v-select.trigger-type-select(
                v-model='campaign.interval.type'
                :label="$t('campaign.triggerType')"
                :items='triggerType'
                item-text='name'
                :disabled='editDisabled'
                @change='changeIntervalType($event)'
                filled
                shaped
                :rules="[() => !!campaign.interval.type || $t('commonPhrases.requiredField')]"
              )
              .d-flex(style='gap: 35px;')
                v-menu(
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto")
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                      v-model="formatedStartDate"
                      :label="$t('campaign.startDate')"
                      hint="DD/MM/AAAA"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-mask="['##/##/####']"
                      v-on="on"
                      :disabled='editDisabled'
                      readonly
                      size="12"
                      :rules="[() => !!formatedStartDate || $t('commonPhrases.requiredField')]"
                    )
                  v-date-picker(
                    v-model="startDate"
                    no-title
                    @input="menu1 = false"
                    :min="today"
                    :max="endDate"
                    :locale="selectedLocale"
                    color='#9c27b0'
                  )
                v-menu(
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  )
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field.trigger-field(
                      v-mask="['##:##']"
                      :label="$t('campaign.hour')"
                      v-model="campaign.interval.time"
                      prepend-icon="mdi-clock-outline"
                      size="5"
                      hint="HH:MM"
                      readonly
                      :disabled='editDisabled'
                      v-bind="attrs"
                      v-on="on"
                      :rules="[() => !!campaign.interval.time || $t('commonPhrases.requiredField')]"
                      persistent-hint
                    )
                  v-time-picker(
                    color='#9c27b0'
                    v-if="menu3"
                    v-model="time"
                    full-width
                    @click:minute="saveTime(time)"
                    format="24hr")
                v-menu(
                  v-if="campaign.interval.type !== 'single'"
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto")
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                      v-if="campaign.interval.type !== 'single'"
                      v-mask="['##/##/####']"
                      :label="$t('campaign.endDate')"
                      v-model="formatedEndDate"
                      hint="DD/MM/AAAA"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      :disabled='editDisabled'
                      readonly
                      size="12"
                    )
                  v-date-picker(
                    v-model="endDate"
                    no-title
                    @input="menu2 = false"
                    :min="startDate"
                    :locale="selectedLocale"
                    color='#9c27b0'
                  )
            div.recurrence-container(v-if="campaign.interval.type === 'week' || campaign.interval.type === 'month' ")
              .title-section(style='font-weight: 400;') {{$t('campaign.repeatEvery')}}
              .d-flex.justify-space-between.align-center
                .d-flex.align-baseline.mr-4
                  v-text-field.shaped.small-text-field.mr-1(
                    v-model="campaign.interval.recurrence.interval"
                    type="number"
                    filled
                    dense
                    placeholder="1"
                    min="1"
                    max="999"
                    @keydown="validateFields($event, campaign.interval.recurrence.interval, 1, 999)"
                    @input="showRecurrenceErrorRequired = false, showRecurrenceErrorInvalidData = false"
                    :disabled='editDisabled'
                    :rules="[() => !!campaign.interval.recurrence.interval || $t('commonPhrases.requiredField')]"
                    )
                  span.font-16 {{campaign.interval.type === 'week'? $t('campaign.week') : $t('campaign.month')}}
                .d-flex(v-if="campaign.interval.type === 'month'")
                  v-radio-group(v-model="recurrenceType" row @change="recurrenceTypeChange($event)")
                    .d-flex
                      v-radio.flex-shrink-0.mr-2(:label="$t('commonWords.onDay')" value="onDay" :disabled='editDisabled')
                      v-text-field.shaped.small-text-field.mr-4(
                        v-model="campaign.interval.recurrence.dayOfMonth"
                        type="number"
                        max="31"
                        min="1"
                        filled
                        placeholder="1"
                        :disabled='editDisabled || recurrenceType === "inThe"'
                        @keydown="validateFields($event, campaign.interval.recurrence.dayOfMonth, 1, 31)"
                        @input="showRecurrenceErrorRequired = false, showRecurrenceErrorInvalidData = false"
                        :rules="[rules.isValid(campaign.interval.recurrence.dayOfMonth, campaign.interval.recurrence.week, selectedWeekday, recurrenceType)]"
                      )
                    .d-flex
                      v-radio.mr-2(:label="$t('commonWords.inThe')" value="inThe" :disabled='editDisabled')
                      v-select.monthly-inputs.mr-2(
                        v-model='campaign.interval.recurrence.week'
                        :items='week'
                        item-text='name'
                        :disabled='editDisabled || recurrenceType === "onDay"'
                        filled
                        shaped
                        :rules="[rules.isValid(campaign.interval.recurrence.dayOfMonth, campaign.interval.recurrence.week, selectedWeekday, recurrenceType)]"
                        @input="showRecurrenceErrorRequired = false, showRecurrenceErrorInvalidData = false"
                      )
                        template(v-slot:label)
                          span(v-if="!campaign.interval.recurrence.week") {{$t('campaign.first')}}
                      v-select.monthly-inputs.mr-2(
                        v-model='selectedWeekday'
                        :items='weekdays'
                        item-text='name'
                        :disabled='editDisabled || recurrenceType === "onDay"'
                        filled
                        shaped
                        :rules="[rules.isValid(campaign.interval.recurrence.dayOfMonth, campaign.interval.recurrence.week, selectedWeekday, recurrenceType)]"
                        @input="showRecurrenceErrorRequired = false, showRecurrenceErrorInvalidData = false"
                      )
                        template(v-slot:label)
                          span(v-if="!selectedWeekday") {{$t('commonWords.monday')}}
                div.d-flex(v-else style='gap: 1rem;')
                  v-btn.weekdays-buttons.mr-2(
                    v-for="weekday in weekdays"
                    :key="weekday.value"
                    :class="{ 'weekday-selected': isWeekdaySelected(weekday.value) }"
                    :disabled='editDisabled'
                    rounded
                    plain
                    elevation="0"
                    @click="addWeekdays(weekday.value)") {{weekday.short}}
              span.text-error(v-if="showRecurrenceErrorRequired") {{$t('commonPhrases.requiredFieldsAbove')}}
              span.text-error(v-if="showRecurrenceErrorInvalidData") {{$t('commonPhrases.invalidFieldsAbove')}}
            .d-flex(style='gap: 1rem; margin: 15px 0 10px;')
              v-btn(
                color='#43a047'
                style='color: white;'
                @click='nextStep()'
                :disabled='dateIsEmpty'
              ) {{$t('commonWords.continue')}}
              v-btn(text @click='prevStep()') {{$t('commonWords.cancel')}}
          template(v-if="isTeamsOrWhatsappActive")
            v-stepper-step(
              :complete="isStepCompleted(6)"
              :step="6"
              :color='method === "view" ? "#9E9E9E" : "#43a047"'
              :editable="isStepCompleted(6) && !methodIsView"
              edit-icon="$complete"
            ) {{$t('campaign.dataCollect')}}
              small.stepper-small-description(v-if="isStepCompleted(6) && step !== 6") {{campaign.monitoringEnabled ? $t('commonWords.enabled'): $t('commonWords.disabled')}}
            v-stepper-content(:step="6")
              section.d-flex.flex-column(style='gap: 10px;')
                .title-section(style='margin-top: 0px; font-weight: 400; color: #000') {{$t('campaign.monitoringInteractions')}}
                .d-flex.justify-space-between.align-center
                  .d-flex.align-center
                    md-switch(v-model='campaign.monitoringEnabled' :disabled='editDisabled')
                    span {{$t('campaign.identifyInteractions')}}
                  span {{campaign.monitoringEnabled ? $t('commonWords.enabled') : $t('commonWords.disabled')}}
                v-select(
                  v-if='campaign.monitoringEnabled'
                  v-model="campaign.monitoringInterval"
                  :items="monitoringIntervals"
                  :label="$t('campaign.monitoringInterval')"
                  :disabled="editDisabled"
                  shaped
                  filled
                )
              .d-flex(style='gap: 1rem;')
                v-btn(color='#43a047' style='color: white;' @click='nextStep()' :disabled='methodIsView') {{$t('commonWords.continue')}}
                v-btn(text @click='prevStep()' :disabled='methodIsView') {{$t('commonWords.cancel')}}
          v-card-actions.text-right(v-if='!editDisabled && completedStepper && !methodIsView')
            v-btn(@click='closeDialog()' text style='margin-right: 10px') {{$t('commonWords.cancel')}}
            v-btn(@click='saveCampaing()' color='#43a047' style='color: white;') {{$t('commonWords.save')}}
      div(v-if="method === 'view' && historyFormated.length > 0")
        v-card-title {{ $t('commonWords.history') }}
        v-row(class="ma-0" style='padding: 16px !important; color: #ABB7C2;' v-for="(item, index) in historyFormated" :key="index")
          v-card-text {{  item.event }} {{ item.name }} {{ $t('commonWords.in') }} {{ item.time }}
  template(v-if='notificationRecipientsListDialog')
    NotificationRecipientsList(
      :dialog.sync='notificationRecipientsListDialog'
      :campaignId='campaignId'
    )
  template(v-if='recipientsDialog')
    NotificationRecipientsListDialog(
      :dialog.sync='recipientsDialog'
      :templateId='selectedTemplate._id || id'
      :campaignId='campaignId'
      :item="recipientItem"
      :canSave="false"
      @recipientList="setRecipientList($event)"
    )
</template>

<script>
import * as moment from 'moment'
import Swal from 'sweetalert2'
import clonedeep from 'lodash.clonedeep'
import { mask } from 'vue-the-mask'
import { selectedLocale } from '@/plugins/i18n'
import TextEditor from '../TextEditor.vue'
import NotificationRecipientsList from './NotificationRecipientsList.vue'
import NotificationRecipientsListDialog from './NotificationRecipientsListDialog.vue'
import MailingRecipientsListPreview from './MailingRecipientsListPreview.vue'
import TriggerTypePreview from './TriggerTypePreview.vue'

const campaignObj = {
  name: '',
  description: '',
  hideSensitiveContent: false,
  active: true,
  monitoringEnabled: true,
  monitoringInterval: 24,
  interval: {
    recurrence: {
      weekdays: []
    }
  },
  recipients: [],
  history: []
}

function isMonthWeekValid (dayOfMonth, week, selectedWeekDay, recurrenceType) {
  if (recurrenceType === 'inThe') {
    return !!week && !!selectedWeekDay
  }
  return !!dayOfMonth
}

export default {
  components: {
    TextEditor,
    NotificationRecipientsList,
    NotificationRecipientsListDialog,
    MailingRecipientsListPreview,
    TriggerTypePreview
  },
  directives: { mask },
  props: {
    dialog: {
      type: Boolean
    },
    editDisabled: {
      type: Boolean
    },
    item: {
      type: Object
    },
    id: {
      type: String,
      default: ''
    },
    editStep: {
      type: Boolean,
      default: false
    },
    method: {
      type: String
    }
  },
  data () {
    return {
      step: 1,
      startDate: undefined,
      endDate: undefined,
      time: undefined,
      menu1: false,
      menu2: false,
      menu3: false,
      textMessage: '',
      campaignId: undefined,
      campaignUpdated: false,
      campaignCreated: false,
      recurrenceType: 'onDay',
      campaign: clonedeep(campaignObj),
      selectedLocale: selectedLocale,
      recipients: [],
      newRecipients: [],
      recipientItem: {},
      file: undefined,
      showRecurrenceErrorRequired: false,
      showRecurrenceErrorInvalidData: false,
      weekdays: [
        { short: 'D', name: this.$t('commonWords.sunday'), value: 'sunday' },
        { short: 'S', name: this.$t('commonWords.monday'), value: 'monday' },
        { short: 'T', name: this.$t('commonWords.tuesday'), value: 'tuesday' },
        { short: 'Q', name: this.$t('commonWords.wednesday'), value: 'wednesday' },
        { short: 'Q', name: this.$t('commonWords.thursday'), value: 'thursday' },
        { short: 'S', name: this.$t('commonWords.friday'), value: 'friday' },
        { short: 'S', name: this.$t('commonWords.saturday'), value: 'saturday' }
      ],
      triggerType: [
        { name: this.$t('campaign.singleTrigger'), value: 'single' },
        { name: this.$t('campaign.daily'), value: 'day' },
        { name: this.$t('campaign.weekly'), value: 'week' },
        { name: this.$t('campaign.monthly'), value: 'month' }
      ],
      week: [
        { name: this.$t('campaign.first'), value: 1 },
        { name: this.$t('campaign.second'), value: 2 },
        { name: this.$t('campaign.third'), value: 3 },
        { name: this.$t('campaign.fourth'), value: 4 }
      ],
      headerRecipient: [
        { text: this.$t('campaign.username'), value: 'name', align: 'center' },
        { text: this.$t('campaign.actions'), value: 'actions', sortable: false, align: 'center' }
      ],
      headers: [ {
        text: this.$t('templateEditDialog.quickReplyTitle'),
        align: 'center',
        sortable: false,
        value: 'title'
      },
      {
        text: this.$t('templateEditDialog.quickReplyPayload'),
        align: 'center',
        sortable: false,
        value: 'payload'
      }
      ],
      templateOptions: [],
      selectedTemplate: {},
      selectedWeekday: '',
      notificationRecipientsListDialog: false,
      recipientsDialog: false,
      templatePage: 0,
      totalPages: 0,
      today: moment().format('YYYY-MM-DD'),
      rules: {
        isValid: (dayOfMonth, week, selectedWeekDay, recurrenceType) => isMonthWeekValid(dayOfMonth, week, selectedWeekDay, recurrenceType) || this.$t('commonPhrases.requiredField')
      },
      activeChannels: [],
      showNameError: false,
      completedStepper: false,
      monitoringIntervals: [
        { text: '12h', value: 12 },
        { text: '24h', value: 24 },
        { text: '36h', value: 36 },
        { text: '48h', value: 48 }
      ],
      history: [
      ],
      interval: {},
      loadingItem: false
    }
  },
  created () {
    this.getTemplates()
    this.startDate = this.today
    if (this.method === 'view') {
      this.step = 7
    }
  },
  computed: {
    dialogComputed: {
      get () {
        return this.dialog
      },
      set (value) {
        this.closeDialog()
      }
    },
    dateIsEmpty () {
      if (this.campaign.interval.type === 'single') {
        return this.startDate && this.time === undefined
      } else if (this.campaign.interval.type === 'day') {
        return this.time === undefined
      } else if (this.campaign.interval.type === 'week') {
        return this.time === undefined || this.campaign.interval.recurrence.weekdays.length === 0 || !this.campaign.interval.recurrence.interval
      } else if (this.campaign.interval.type === 'month' && this.recurrenceType === 'onDay') {
        return this.time === undefined || !this.campaign.interval.recurrence.dayOfMonth || !this.campaign.interval.recurrence.interval
      } else if (this.campaign.interval.type === 'month' && this.recurrenceType === 'inThe') {
        return this.time === undefined || !this.selectedWeekday || !this.campaign.interval.recurrence.week || !this.campaign.interval.recurrence.interval
      }
      return true
    },
    isTeamsOrWhatsappActive () {
      if (this.selectedTemplate && this.selectedTemplate.channels) {
        return this.selectedTemplate.channels.some(channel => ['teams', 'whatsapp'].includes(channel.name) && channel.isActive)
      }
      return false
    },
    formatedStartDate: {
      get () {
        return moment(this.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      },
      set (val) {
        this.campaign.interval.startDate = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    },
    formatedEndDate: {
      get () {
        return moment(this.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      },
      set (val) {
        this.campaign.interval.endDate = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    },
    selectedTriggerTypeName () {
      if (!this.campaign.interval.type) return ''
      return this.triggerType.find(trigger => trigger.value === this.campaign.interval.type).name
    },
    hasQuickReplies () {
      return this.selectedTemplate?.messageOptions?.options?.quick_replies?.length > 0
    },
    methodIsView () {
      return this.method === 'view'
    },
    historyFormated () {
      return this.history.map(item => {
        return (
          {
            event: this.$t(`templateEditDialog.history.${item.event}`),
            name: item.user.name,
            time: moment(item.time).format('DD/MM/YYYY HH:mm:ss')
          }
        )
      })
    }
  },
  methods: {
    getActiveChannels (channelsArray) {
      return channelsArray.filter(channel => channel.isActive)
    },
    nextStep () {
      if ((this.step >= 5 && !this.isTeamsOrWhatsappActive) || (this.step === 6 && this.isTeamsOrWhatsappActive)) {
        this.completedStepper = true
      }
      this.step++
    },
    prevStep () {
      this.step--
    },
    debounceCallback (callback, delay) {
      let timer
      return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          callback(null, ...args)
        }, delay)
      }
    },
    async validateName (name) {
      try {
        await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/campaign/validation-name`, {
          params: {
            name: name.trim()
          }
        })
        this.showNameError = false
      } catch (error) {
        this.showNameError = true
      }
    },
    debouncedNameValidation (name) {
      this.debounceCallback(this.validateName(name), 500)
    },
    isStepCompleted (step) {
      if (this.editStep) {
        return true
      }
      return step < this.step
    },
    validateFields (event, currentValue, min = null, max = null) {
      const systemAllowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab']
      if (systemAllowedKeys.includes(event.key)) {
        return
      }
      const numbersRegex = new RegExp(/^[0-9]+$/)
      if (!numbersRegex.test(event.key)) {
        event.preventDefault()
      }
      const value = parseInt(currentValue + event.key)
      if (min && value < min) {
        event.preventDefault()
      }
      if (max && value > max) {
        event.preventDefault()
      }
    },
    closeDialog () {
      this.step = 1
      this.completedStepper = false
      this.campaign = clonedeep(campaignObj)
      this.startDate = undefined
      this.endDate = undefined
      this.time = undefined
      this.showRecurrenceErrorRequired = false
      this.recipients = []
      this.newRecipients = []
      this.$emit('closeDialog')
    },
    changeIntervalType (type) {
      this.showRecurrenceErrorRequired = false
      this.campaign = {
        ...this.campaign,
        interval: {
          time: this.time,
          recurrence: {
            weekdays: []
          },
          type
        }
      }
    },
    onTemplateChange (_) {
      this.file = undefined
      this.recipients = []
    },
    getStatus (channel) {
      let status = channel === undefined ? '' : channel.toLowerCase()
      if (status === 'approved') {
        return this.$t('templateEditDialog.approved')
      } else if (status === 'not approved') {
        return this.$t('templateEditDialog.notApproved')
      } else {
        return this.$t('templateEditDialog.notConfigured')
      }
    },
    getStatusText (channel) {
      let text = channel.text ?? channel.name
      if (channel.name === 'whatsapp' && channel.status !== 'APPROVED') {
        text = 'Whatsapp ' + this.$t('templateEditDialog.whatsappApproval') + '- 48h'
        return text
      }
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    async getTemplates () {
      const response = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates`, {
        params: {
          page: this.templatePage,
          perPage: 5,
          order: 'desc',
          isActive: true
        }
      })
      this.templateOptions = [
        ...this.templateOptions,
        ...response.data.data
      ]
      this.totalPages = response.data.total / 5
    },
    async getTemplate (id) {
      const response = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${id}`)
      return response.data._source
    },
    addWeekdays (value) {
      this.showRecurrenceErrorRequired = false
      if (this.campaign.interval.recurrence.weekdays.some(weekday => weekday === value)) {
        this.campaign.interval.recurrence.weekdays = this.campaign.interval.recurrence.weekdays.filter(weekday => weekday !== value)
      } else {
        this.campaign.interval.recurrence.weekdays.push(value)
      }
      this.$forceUpdate()
    },
    isWeekdaySelected (value) {
      if (this.campaign.interval.recurrence?.weekdays.length > 0) {
        return this.campaign.interval.recurrence.weekdays.some(weekday => weekday === value)
      }
    },
    recurrenceTypeChange (type) {
      this.showRecurrenceErrorRequired = false
      if (type === 'onDay') {
        this.campaign.interval.recurrence.week = undefined
        this.selectedWeekday = ''
      } else {
        this.campaign.interval.recurrence.dayOfMonth = undefined
      }
    },
    async onIntersect () {
      if (this.templatePage < this.totalPages) {
        this.templatePage += 1
        await this.getTemplates()
      }
    },
    viewRecipientList () {
      this.notificationRecipientsListDialog = true
    },
    addRecipientsManually () {
      if (this.selectedTemplate._id) {
        this.recipientsDialog = true
        this.recipientItem = {}
      } else {
        Swal.fire({
          title: this.$t('testNotificationDialog.selectTemplateLabel'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    onFileChanged (e) {
      this.file = e
    },
    clearFile (e) {
      e.target.value = null
    },
    downloadTemplateFile () {
      if (this.selectedTemplate._id) {
        this.$axios({
          method: 'get',
          url: `/campaign/template/${this.selectedTemplate._id}/contacts/import`,
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'file.xlsx')
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        }).catch(() => {
          Swal.fire({
            title: this.$t('notificationCampaignDialog.downloadError'),
            icon: 'warning',
            showConfirmButton: false,
            timer: 2000
          })
        })

        this.$axios({
          method: 'get',
          url: `/campaign/template/${this.selectedTemplate._id}/contacts/import?fileType=csv`,
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'file.csv')
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        }).catch(() => {
          Swal.fire({
            title: this.$t('notificationCampaignDialog.downloadError'),
            icon: 'warning',
            showConfirmButton: false,
            timer: 2000
          })
        })
      } else {
        Swal.fire({
          title: this.$t('testNotificationDialog.selectTemplateLabel'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    importFile () {
      if (this.selectedTemplate._id) {
        document.getElementById('uploader').click()
      } else {
        Swal.fire({
          title: this.$t('testNotificationDialog.selectTemplateLabel'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    async getRecipientList (campaignId, channels) {
      const response = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/campaign/${campaignId}/contacts`)
      const contactsArray = response.data.data.map(contact => (
        {
          name: contact._source.name,
          contacts: contact._source.contacts
        }
      ))
      const channelsArray = channels.map(channel => channel.name)
      this.recipients = contactsArray.map(contactObj => (
        {
          contacts: contactObj.contacts.filter(contact => channelsArray.includes(contact.channel)),
          ...contactObj
        }
      )
      )
    },
    setRecipientList (recipient) {
      this.newRecipients.push(recipient)
    },
    removeRecipient (index) {
      this.recipients.splice(index, 1)
    },
    saveTime (time) {
      this.menu3 = false
      this.campaign.interval.time = time
    },
    formIsValid () {
      let typeIsWeek = this.campaign.interval.type === 'week'
      let typeIsMonth = this.campaign.interval.type === 'month'
      if ((typeIsWeek || typeIsMonth) && !this.campaign.interval.recurrence.interval) {
        this.showRecurrenceErrorRequired = true
        return false
      }
      if ((typeIsWeek || typeIsMonth) && this.campaign.interval.recurrence?.interval <= 0) {
        this.showRecurrenceErrorInvalidData = true
        return false
      }
      if ((typeIsWeek) && (this.campaign.interval.recurrence.weekdays.length === 0)) {
        this.showRecurrenceErrorRequired = true
        return false
      }
      if (typeIsMonth && this.recurrenceType === 'onDay' && !this.campaign.interval.recurrence.dayOfMonth) {
        this.showRecurrenceErrorRequired = true
        return false
      }
      if (typeIsMonth && this.recurrenceType === 'onDay' && this.campaign.interval.recurrence.dayOfMonth <= 0) {
        this.showRecurrenceErrorInvalidData = true
        return false
      }
      if (typeIsMonth && this.recurrenceType === 'inThe' && (!this.campaign.interval.recurrence.week || !this.selectedWeekday)) {
        this.showRecurrenceErrorRequired = true
        return false
      }
      this.showRecurrenceErrorRequired = false
      return true
    },
    async saveCampaing () {
      try {
        const isRefsValid = this.$refs.registerCampaign.validate()
        const isFormValid = this.formIsValid()
        if (isRefsValid && isFormValid) {
          this.campaign.templateId = this.selectedTemplate._id
          this.campaign.templateName = this.selectedTemplate.name
          this.campaign.recipients = this.newRecipients
          this.campaign.timezone = moment().format('Z')
          this.campaign.interval.startDate = moment(this.formatedStartDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          this.campaign.interval.endDate = this.endDate ? moment(this.formatedEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : undefined
          if (this.campaign.interval.type === 'single') {
            delete this.campaign.interval.endDate
            delete this.campaign.interval.recurrence
          } else if (this.campaign.interval.type === 'day') {
            delete this.campaign.interval.recurrence
          } else if (this.campaign.interval.type === 'week') {
            delete this.campaign.interval.recurrence.dayOfMonth
            delete this.campaign.interval.recurrence.week
          } else if (this.campaign.interval.type === 'month') {
            this.campaign.interval.recurrence.weekdays = this.selectedWeekday.length > 0 ? [this.selectedWeekday] : undefined
          }
          let response
          if (this.campaignId) {
            response = await this.$axios.put(`/campaign/${this.campaignId}`, this.campaign)
            this.campaignUpdated = true
          } else {
            response = await this.$axios.post('/campaign', this.campaign)
            this.campaignCreated = true
            this.campaignId = response.data._id
          }
          if (this.file) {
            let fileForm = new FormData()
            fileForm.append('file', this.file)
            await this.$axios.post(`/campaign/${this.campaignId}/contacts/import`, fileForm)
          }
          const warningRecipientsOutdated = response?.data?.warning?.find(warning => warning.type === 'recipientsOutdated')
          const warningRecipientsAlreadyExist = response?.data?.warning?.find(warning => warning.type === 'recipientsAlreadyExist')
          const getHtmlText = () => {
            if (warningRecipientsOutdated && warningRecipientsAlreadyExist) {
              return `${this.$t('campaign.warningTemplateChanged', [warningRecipientsOutdated.count])} ${this.$t('campaign.warningRecipientsAlreadyExist', [warningRecipientsAlreadyExist.count])}`
            } else if (warningRecipientsOutdated) {
              return this.$t('campaign.warningTemplateChanged', [warningRecipientsOutdated.count])
            } else if (warningRecipientsAlreadyExist) {
              return this.$t('campaign.warningRecipientsAlreadyExist', [warningRecipientsAlreadyExist.count])
            } else {
              return ''
            }
          }
          Swal.fire({
            title: this.campaignUpdated ? this.$t('campaign.campaignSuccessfullyEdited') : this.$t('campaign.campaignCreatedSuccessfully'),
            html: getHtmlText(),
            icon: 'success',
            showConfirmButton: warningRecipientsOutdated || warningRecipientsAlreadyExist,
            timer: (warningRecipientsOutdated || warningRecipientsAlreadyExist) ? undefined : 2000
          })
          setTimeout(() => {
            this.$emit('rerender')
            this.closeDialog()
            this.campaignCreated = false
            this.campaignUpdated = false
          }, 2000)
        }
      } catch (error) {
        if (error.response?.status === 422) {
          Swal.fire({
            icon: 'warning',
            title: 'Campanha cadastrada.',
            html: this.$t('notificationCampaignDialog.saveCampaingErrorHtml'),
            showConfirmButton: true
          })
          setTimeout(() => {
            this.$emit('rerender')
            this.closeDialog()
          }, 2000)
        } else {
          this.campaign = clonedeep(campaignObj)
          Swal.fire({
            icon: 'error',
            title: '',
            html: `${error}`
          })
        }
      }
    }
  },
  watch: {
    item: {
      deep: true,
      async handler (value) {
        try {
          this.loadingItem = true
          if (value._id) {
            if (this.method === 'view') {
              this.step = 10
            }
            this.file = undefined
            this.campaignId = value._id
            this.campaign = clonedeep(value._source)
            this.startDate = this.campaign.interval.startDate
            this.endDate = this.campaign.interval.endDate
            this.time = this.campaign.interval.time
            this.interval = this.campaign.interval
            this.selectedTemplate = await this.getTemplate(this.campaign.templateId)
            this.selectedTemplate._id = this.campaign.templateId
            this.activeChannels = this.getActiveChannels(this.selectedTemplate.channels)
            this.getRecipientList(this.campaignId, this.activeChannels)
            if (this.campaign.interval.type === 'month') {
              this.selectedWeekday = this.campaign.interval.recurrence && this.campaign.interval.recurrence.weekdays ? this.campaign.interval.recurrence.weekdays[0] : undefined
              this.recurrenceType = this.campaign.interval.recurrence.dayOfMonth ? 'onDay' : 'inThe'
            } else if (this.campaign.interval.type === 'week') {
            } else {
              this.campaign.interval.recurrence = {
                weekdays: []
              }
            }
          } else {
            this.campaign = clonedeep(campaignObj)
            this.selectedTemplate = {}
            this.endDate = undefined
            this.campaignId = undefined
            this.file = undefined
            this.startDate = this.today
            this.$nextTick(() => {
              this.$refs.registerCampaign.resetValidation()
            })
          }
        } catch (e) {
          Swal.fire({
            icon: 'error',
            title: this.$t('campaign.campaignError'),
            html: `${e}`
          })
        } finally {
          this.loadingItem = false
          this.$forceUpdate()
        }
      }
    },
    selectedTemplate: {
      deep: true,
      handler (value) {
        if (value && value.messageOptions) {
          this.activeChannels = value.channels.filter(channel => channel.isActive)
          this.textMessage = value.messageOptions.text[0]
        } else {
          this.textMessage = ''
        }
      }
    },
    'campaign.interval.recurrence': {
      deep: true,
      handler (newValue) {
        if (newValue && (newValue.interval === '0' || newValue.interval === '00')) {
          this.$nextTick(() => {
            newValue.interval = '1'
          })
        }
        if (newValue && newValue.dayOfMonth === '0') {
          this.$nextTick(() => {
            newValue.dayOfMonth = '1'
          })
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.monthly-inputs {
  max-width: 200px;
  width: 187px;
}

.sectionGapPadding {
  gap: 10px;
  padding-bottom: 10px;
}
.title-section{
  margin: 0 0 5px;
  font-size: 16px;
  color: #000000;
}

.content-dialog {
  padding: 0 30px 20px 30px !important;
}

.weekdays-buttons {
  min-width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  font-size: 18px !important;
  line-height: 21.09px !important;

  ::v-deep .v-btn__content {
    opacity: 1 !important;
  }

  &.weekday-selected {
    background-color: #31A44C;
    color: #FFFFFF;
  }
}

.trigger-type-select {
  width: 250px;
  flex-grow: 0;
  margin-right: 30px !important;
}

.trigger-field {
  margin-right: 30px !important;
}

.v-text-field {

  &.shaped {
    border-radius: 10px 10px 0px 0px;
  }

  &.v-input--is-focused {
    ::v-deep fieldset {
      border: none;
    }
  }
  ::v-deep fieldset {
    border: none;
  }
}

.v-file-input {
  width: 300px !important;
}
small {
  margin-top: 5px !important;
}

.small-text-field {
  width: 70px;
}

.recurrence-container {
  &.v-input {
    align-items: center;
  }

  ::v-deep .v-input__slot {
    min-height: 52px !important;
    margin-bottom: 8px;
  }

  ::v-deep .v-text-field__details {
    display: none;
  }

  ::v-deep .v-input--radio-group__input {
    flex-wrap: nowrap;
  }
  ::v-deep .v-label {
    margin-left: 5px;
  }
}

.font-16 {
  font-size: 16px;
}

.margin-negative {
  margin-top: -15px;
}

.md-switch {
  margin: 5px 16px 5px 0;
  ::v-deep .md-switch-label {
    color: rgba(0,0,0,.6);
  }
}

.text-editor {
  margin-top: 5px;
  & ::v-deep .quill-editor .ql-container {
    background-color: transparent !important;
    border: 0 !important;
    & .ql-editor {
      padding: 0 !important;
    }
  }
}

.v-select {
  ::v-deep label {
    color: #949494;
  }
}

.quick-reply {
  margin-right: 10px !important;
  flex: none;

  ::v-deep input {
    color: rgba(0,0,0,.87) !important;
  }

  ::v-deep .v-input__slot {
    min-height: 40px !important;
    background-color: #ff9800 !important;
  }
}

.quick-replies-buttons {
  margin-top: 10px;
}

.v-card__text {
  padding: 0 !important;
}

.v-card__actions {
  width: 100%;
}

.text-error {
  color: #ff5252 !important;
  font-size: 12px;
}

.template-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.stepper {
  ::v-deep .v-stepper__label   {
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #0D0B26 !important;
  }
  ::v-deep .v-stepperstepstep > i {
    font-size: 13px;
  }
}

div ::-webkit-scrollbar {
  width: 6px;
}

div ::-webkit-scrollbar-track {
  border-radius: 3.5px;
  background-color: #fff;
}

div ::-webkit-scrollbar-thumb {
  border-radius: 3.5px;
  background-color: #00000024;
}
::v-deep .v-skeleton-loader__avatar {
  width: 32px !important;
  height: 32px !important;
}

.stepper-small-description {
  color: #ABB7C2;
  font-size: 14px !important;
  font-weight: 400 !important;
}

</style>
